import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const NotFoundPage = () => {
    return (_jsxs("div", { children: [_jsx("h1", { children: "404 - Page Not Found" }), _jsx("p", { children: "Sorry, the page you are looking for does not exist." })] }));
};
export default NotFoundPage;
